import { ref } from 'vue'

/**
 * 倒计时
 * @returns
 */
export default function useTimer() {
  const count = ref(0)
  /**定时器 */
  const timer = ref<any>(null)
  const timeEnd = ref(false)
  const sendFlag = ref(false)

  /**开始倒计时 */
  const begin = (nums: number) => {
    count.value = nums
    timeEnd.value = false
    sendFlag.value = true
    clearInterval(timer.value)
    timer.value = null
    timer.value = setInterval(() => {
      if (count.value <= 0) {
        timeEnd.value = true
        clearInterval(timer.value)
        timer.value = null
      } else {
        count.value--
      }
    }, 1000)
  }

  return {
    /**倒计时时长 */
    count,
    /**判断倒计时结束 */
    timeEnd,
    /**已发送标识 */
    sendFlag,
    /**开始计时 */
    begin
  }
}
